import React, { useEffect, useState } from 'react'
import style from './CartPopupModel.module.css'
import ReactDOM from 'react-dom'
import Icon from "react-icons-kit"
import { fileTextO } from "react-icons-kit/fa/fileTextO"
import { useNavigate } from 'react-router-dom'
const CartPopupModel = () => {


    const [isOpen, setIsOpen]=useState(true)
    const navigate=useNavigate()
    // useEffect(() => {
    //     const timer = setTimeout(() => {

    //       setIsOpen(false);
    //     }, 5000);
    
    //     return () => clearTimeout(timer);
    //   }, [])
    // if (!isOpen)

    //     return null
  return ReactDOM.createPortal(
    <div className={`${style.cartModel} ${style.bounceOnce}`} onClick={()=>navigate("/dashboard/cart")}>
        <div className={style.cartHeader}>

      {/* 🛒 Cart Updated */}
      <img src="/Checked.gif" alt="CheckedGif" style={{width:"100px", height:"100px"}} />
        </div>

        <div className={style.cartDetails}>
            {/* <div className={style.icon}>
                <Icon icon={fileTextO} size={25}/>
            </div> */}
                <h3 className={style.cartItem}>Request Added Successfully</h3>

        </div>


    <div style={{display:"flex", justifyContent:"center"}}>
        <button className='btn primaryBtn'>View Cart</button>
    </div>

    </div>,
    document.body
  )
}

export default CartPopupModel